(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-ticker"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializedSections = new WeakSet();

    const setupTicker = (section) => {
      if (!section || initializedSections.has(section)) return;

      const marquee = section.querySelector('.announcement-ticker__marquee');
      const track = section.querySelector('.announcement-ticker__track');

      if (!marquee || !track) return;

      const updateDistance = () => {
        const loopDistance = track.getBoundingClientRect().width;

        if (!loopDistance) return;

        section.style.setProperty('--ticker-loop-distance', `${loopDistance}px`);
        section.classList.add('announcement-ticker--ready');
      };

      const resizeObserver = new ResizeObserver(() => {
        updateDistance();
      });

      resizeObserver.observe(section);
      resizeObserver.observe(track);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          updateDistance();
        });
      }

      updateDistance();
      initializedSections.add(section);
    };

    const initTickers = (root = document) => {
      root.querySelectorAll('.announcement-ticker--animated').forEach((section) => {
        setupTicker(section);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initTickers(), { once: true });
    } else {
      initTickers();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initTickers(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class DesktopHeaderSearch extends HTMLElement {
    constructor() {
      super();

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
      this.onViewportChange = this.onViewportChange.bind(this);
      this.onMegaMenuToggle = this.onMegaMenuToggle.bind(this);
      this.onTriggerClick = this.onTriggerClick.bind(this);
    }

    connectedCallback() {
      this.header = this.closest('.header-wrapper');
      this.stickyHeader = this.closest('sticky-header');
      this.triggerButton = this.querySelector('[data-header-search-trigger]');
      this.panel = this.querySelector('[data-header-search-panel]');
      this.panelInput = this.querySelector('[data-header-search-input]');
      this.closeButton = this.querySelector('[data-header-search-close]');
      this.predictiveSearch = this.querySelector('predictive-search');
      this.headerMenus = this.header ? this.header.querySelectorAll('header-menu details') : [];
      this.disclosures = this.header ? this.header.querySelectorAll('header-menu') : [];
      this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');

      if (!this.triggerButton || !this.panel || !this.panelInput) return;

      this.triggerButton.addEventListener('click', this.onTriggerClick);
      this.closeButton.addEventListener('click', () => this.close({ returnFocus: true }));
      this.desktopMediaQuery.addEventListener('change', this.onViewportChange);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onDocumentKeydown);
      this.headerMenus.forEach((menu) => menu.addEventListener('toggle', this.onMegaMenuToggle));
    }

    disconnectedCallback() {
      if (!this.triggerButton || !this.panel || !this.panelInput) return;

      this.triggerButton.removeEventListener('click', this.onTriggerClick);
      this.desktopMediaQuery.removeEventListener('change', this.onViewportChange);
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onDocumentKeydown);
      this.headerMenus.forEach((menu) => menu.removeEventListener('toggle', this.onMegaMenuToggle));
    }

    isDesktop() {
      return this.desktopMediaQuery.matches;
    }

    isOpen() {
      return this.hasAttribute('open');
    }

    onTriggerClick() {
      if (!this.isDesktop()) return;

      if (this.isOpen()) {
        this.close({ returnFocus: false });
        return;
      }

      this.open();
    }

    open() {
      if (!this.isDesktop()) return;

      this.closeMenuDisclosure();
      this.panel.hidden = false;
      this.setAttribute('open', '');
      this.triggerButton.setAttribute('aria-expanded', 'true');

      if (this.header) {
        this.header.preventHide = true;
      }

      if (this.stickyHeader) {
        this.stickyHeader.preventHide = true;
      }

      this.panelInput.focus();
    }

    close({ returnFocus = false } = {}) {
      if (!this.isOpen()) return;

      this.removeAttribute('open');
      this.panel.hidden = true;
      this.triggerButton.setAttribute('aria-expanded', 'false');
      this.predictiveSearch?.close();

      if (this.header) {
        this.header.preventHide = false;
      }

      if (this.stickyHeader) {
        this.stickyHeader.preventHide = false;
      }

      if (returnFocus) {
        this.triggerButton.focus();
      }
    }

    closeMenuDisclosure() {
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    onDocumentClick(event) {
      if (!this.isOpen()) return;
      if (this.contains(event.target)) return;

      this.close();
    }

    onDocumentKeydown(event) {
      if (event.code.toUpperCase() !== 'ESCAPE' || !this.isOpen()) return;

      event.preventDefault();
      this.close({ returnFocus: true });
    }

    onViewportChange(event) {
      if (event.matches) return;

      this.close();
    }

    onMegaMenuToggle(event) {
      if (event.currentTarget.open) {
        this.close();
      }
    }
  }

  customElements.define('desktop-header-search', DesktopHeaderSearch);

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.querySelector('predictive-search[open]')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.desktopSearch = this.desktopSearch || this.header.querySelector('desktop-header-search');

      if (this.searchModal) {
        this.searchModal.close(false);
      }

      if (this.desktopSearch) {
        this.desktopSearch.close();
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
